import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "file-word",
  "use": "file-word-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"file-word\"><path d=\"M319.889 237.946h22.105l-25.506 113.089-33.162-159.005h-53.275l-38.557 159.005-28.908-159.005h-55.697l56.546 255.94h54.419l38.147-151.354 34.128 151.354h50.168l64.814-255.94h-85.223v45.916z\" /><path d=\"M458.903 114.538c-11.105-15.146-26.587-32.85-43.589-49.852s-34.706-32.482-49.852-43.589C339.675 2.187 327.166 0 320 0H72C49.944 0 32 17.944 32 40v432c0 22.056 17.943 40 40 40h368c22.056 0 40-17.944 40-40V160c0-7.166-2.186-19.675-21.097-45.462zm-66.216-27.225c15.35 15.35 27.4 29.199 36.29 40.687H352V51.027c11.491 8.89 25.339 20.939 40.687 36.286zM448 472c0 4.336-3.664 8-8 8H72c-4.336 0-8-3.664-8-8V40c0-4.336 3.664-8 8-8h248v112c0 8.836 7.162 16 16 16h112v312z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/file-word.svg
// module id = aK1D
// module chunks = 1